import React, { useState, useRef } from "react";
import ReactDOM from "react-dom";
import genStyles from "./generale.module.css";

export default function TooltipForm({ children, content, classNameplus }) {
  const [position, setPosition] = useState({ top: 0, left: 0 });
  const [visible, setVisible] = useState(false);
  const wrapperRef = useRef(null);

  const showTooltip = () => {
    if (wrapperRef.current) {
      const rect = wrapperRef.current.getBoundingClientRect();
      setPosition({
        top: rect.top + window.scrollY - 10, // position verticale
        left: rect.left + window.scrollX + rect.width + 10 // à droite
      });
    }
    setVisible(true);
  };

  const hideTooltip = () => setVisible(false);

  return (
    <>
      <span
        ref={wrapperRef}
        className={classNameplus || genStyles.tooltipWrapper}
        onMouseEnter={showTooltip}
        onMouseLeave={hideTooltip}
      >
        {children}
      </span>

      {visible &&
        ReactDOM.createPortal(
          <div
            className={genStyles.tooltipBubble}
            style={{ top: position.top, left: position.left }}
          >
            {content}
          </div>,
          document.body
        )}
    </>
  );
}
